module.exports = __webpack_public_path__ + "static/media/floorball.786cdd2e.svg";